import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import BlogForm from '../../../../components/forms/BlogForm/BlogForm';
import axios from 'axios';
import { toast } from 'react-toastify';

const EditBlog = () => {
    const { id } = useParams();
    const [newsData, setNewsData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchNewsData();
    }, [id]);

    const fetchNewsData = async () => {
        try {
            const response = await axios.get(`https://api.admin-panel.nhcholding.com/api/news/${id}/edit`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            // Extract the news data from the response
            setNewsData(response.data.news);
        } catch (error) {
            console.error('Error fetching news data:', error);
            toast.error('Failed to load news data');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Container fluid>
                <div className="text-center p-5">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <p>Loading news data...</p>
                </div>
            </Container>
        );
    }

    return (
        <Container fluid>
            <div className='mt-5 mb-5'>
                <h3>Edit News</h3>
            </div>
            <Row>
                <Col md={4}>
                    <h5>Edit the news</h5>
                    <p>Update the news about Najeeb Auto.</p>
                </Col>

                <Col md={8}>
                    <BlogForm 
                        newsId={id}
                        isEditMode={true}
                        initialValues={newsData}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default EditBlog;
